import type { MonospacePolicyEntitlementResource } from '#layers/access';
import { RStoreSchema } from '#imports';
import { parseEntitlementResources } from './parse-entitlement-resources';

export const ProjectEntitlementResource = RStoreSchema.withItemType<MonospacePolicyEntitlementResource>().defineCollection({
	name: 'ProjectEntitlementResource',
	getKey: (item) => item.name,
	meta: {
		useProjectSlug: true,
		endpoint: 'entitlements',
		parse: { many: parseEntitlementResources },
	},
});
